import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licence-content',
  templateUrl: './licence-content.component.html',
  styleUrls: ['./licence-content.component.scss'],
})
export class LicenceContentComponent implements OnInit {
  year: number = null;

  constructor() {}

  ngOnInit() {
    this.year = new Date().getFullYear();
  }
}
